import * as yup from 'yup'

export default yup.object().shape({
  fullName: yup.string().required('Campo obrigatório'),
})
